import React from 'react';

import { WarningOutlined as Warning } from '@ant-design/icons';

import { useFormikContext } from 'formik';
import { CurrencyId } from 'v2/interfaces/financial';
import type { INewAccount } from 'v2/interfaces/financial';

const Resume = () => {
  const { values } = useFormikContext<INewAccount>();

  const accountWithDigit = () => `${values.account || ''}${values.account_digit ? `-${values.account_digit}` : ''}`;
  const agencyWithDigit = () => `${values.agency || ''}${values.agency_digit ? `-${values.agency_digit}` : ''}`;

  function getAccountType(type: string) {
    const accountTypes = {
      CC: 'Conta Corrente',
      CP: 'Conta Poupança'
    };

    return accountTypes[type as keyof typeof accountTypes] || '';
  }

  const accountType = getAccountType(values.type);
  const isBRLSelected = values.currency === CurrencyId.BRL;
  const shouldDisplayAccountType = accountType && isBRLSelected;

  return (
    <div className='flex h-full flex-col justify-between'>
      <div>
        <p className='m-0! text-[19px] font-bold text-[#5e5e5e] uppercase'>{values.name}</p>

        <p className='m-0! text-[15px] text-[#878787] uppercase'>{isBRLSelected ? 'BRL' : 'USD'}</p>

        <div className='mt-2' />

        <p className='m-0!'>Banco: {values.bank_id || ''}</p>

        {values.operation_id !== 'not-selected' && values.operation_id && (
          <p className='m-0!'>Operação: {values.operation_id || ''}</p>
        )}

        <p className='m-0!'>Agência: {agencyWithDigit()}</p>

        <p className='m-0!'>Conta: {accountWithDigit()}</p>

        {shouldDisplayAccountType && <p className='m-0!'>Tipo de conta: {accountType}</p>}
      </div>

      <div className='m-4'></div>
      <div className='flex items-center rounded-sm bg-[#ffedb8] p-3'>
        <Warning className='mr-4 text-2xl' />
        <p className='text-base'>
          Ao clicar em finalizar você receberá um e-mail de confirmação que deve ser validado para conclusão do seu
          cadastro. Caso tenha alguma dúvida é só nos chamar no chat do menu de ajuda ou entrar em contato em{' '}
          <b>suporte@eduzz.com</b>.
        </p>
      </div>
    </div>
  );
};
export default Resume;
